import {writable} from '@convincely/components/src/library.js';

export const calloutStore = writable({});
export const leadResponse = writable({});
export const redirectOnSuccessStore = writable(undefined);
